module.exports = __webpack_public_path__ + "img/cle.7436ac9a.svg";